export function formatDate(dateString) {
    // Create a Date object from the input string
    const date = new Date(dateString);
    
    // Extract day, month, and year
    const day = date.getDate();
    const month = date.getMonth() + 1; // Months are zero-based
    const year = date.getFullYear();
    
    // Return formatted date
    return `${day}.${month}.${year}`;
}
